import React, { useEffect, useCallback, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBasketShopping } from '@fortawesome/free-solid-svg-icons';

import { setFlashMessage, useWebsite } from '../contexts/WebsiteContext';
import config from '../config/config';
import SupplierItem from '../components/SupplierItem';
import { useAuth } from '../contexts/AuthContext';
import { useMode } from '../contexts/ModeContext';

const { apiUrl } = config;
const apiPath = `${apiUrl}supplier`;

function SupplierList({ refreshList, isSubtitle }) {

    const [items, setItems] = useState([]);
    const { isModeAdmin } = useMode();
    const { website } = useWebsite();
    const { token } = useAuth();
    const { t } = useTranslation();

    // 🔹 Fetch suppliers
    const fetchItems = useCallback(async () => {
        if (!website) return;

        try {
            const response = await axios.get(
                `${apiPath}?website=${website}`
            );
            setItems(response.data || []);
        } catch (error) {
            console.error(error);
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }
    }, [website, t]);

    useEffect(() => {
        fetchItems();
    }, [fetchItems, refreshList]);

    // 🔹 Delete supplier
    const handleDelete = async (itemId) => {
        try {
            await axios.delete(`${apiPath}/${itemId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            await fetchItems();
            setFlashMessage(t('SUCCESS_DELETED_MESSAGE'), 'success');

        } catch (error) {
            console.error(error);
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }
    };

    // 🔹 Update ranking
    const handleRankingUpdate = async (direction, itemId) => {
        try {
            await axios.put(
                `${apiPath}/${itemId}`,
                { ranking: direction },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            await fetchItems();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');

        } catch (error) {
            console.error(error);
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }
    };

    // 🔹 Edit supplier
    const handleEdit = async (itemId, editedSupplier) => {
        try {
            await axios.put(
                `${apiPath}/${itemId}`,
                editedSupplier,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            await fetchItems();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');

        } catch (error) {
            console.error(error);
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }
    };

    return (
        <>
            {/* Title */}
            {isSubtitle && (isModeAdmin || items.length > 0) && (
                <h2>
                    <FontAwesomeIcon icon={faBasketShopping} /> {t('SUPPLIERS')}
                </h2>
            )}

            {/* Empty state (admin only) */}
            {isModeAdmin && items.length === 0 && (
                <p>La liste des fournisseurs est vide</p>
            )}

            {/* List */}
            {items.map((supplier, index) => (
                <SupplierItem
                    key={supplier.id}
                    supplier={supplier}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                    handleRankingUpdate={handleRankingUpdate}
                    isFirst={index === 0}
                    isLast={index === items.length - 1}
                />
            ))}
        </>
    );
}

export default SupplierList;